<template>
  <el-dialog title="设备信息" :visible="true" :before-close="closeBox">
    <el-form>
      <el-form-item label="设备编号">
        <el-input
          v-model="form.machine_no"
          placeholder="设备编号"
          :disabled="form.machine_id != ''"
        ></el-input>
      </el-form-item>
      <el-form-item label="格口数量">
        <span style="color: red"
          >（设置格口数量需小于实际格口数量，留出异常格口）</span
        >
        <el-input v-model="form.grid_num" placeholder="格口数量"></el-input>
      </el-form-item>
      <el-form-item label="IP">
        <el-input v-model="form.ip" placeholder="IP"></el-input>
      </el-form-item>
      <el-form-item label="端口">
        <el-input v-model="form.port" placeholder="port"></el-input>
      </el-form-item>
      <el-form-item label="一键打包:">
        <el-select v-model="form.is_check_one_out" placeholder="一键打包">
          <el-option
            v-for="item in ops_is_check_one_out"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeBox">取 消</el-button>
      <el-button type="primary" @click="addMachine">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    machine_id: {
      type: String,
      default: "",
    },
    machine_no: {
      type: String,
      default: "",
    },
    grid_num: {
      type: String,
      default: "",
    },
    ip: {
      type: String,
      default: "",
    },
    port: {
      type: String,
      default: "",
    },
    is_check_one_out: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        machine_id: "",
        machine_no: "",
        grid_num: "",
        is_check_one_out: "",
        port: "",
        ip: "",
      },
      ops_is_check_one_out: [
        { key: "1", name: "是" },
        { key: "2", name: "否" },
      ],
    };
  },
  mounted() {
    this.filteredForm();
  },
  methods: {
    filteredForm() {
      this.form.machine_id = this.machine_id;
      this.form.machine_no = this.machine_no;
      this.form.grid_num = this.grid_num;
      this.form.ip = this.ip;
      this.form.port = this.port;
      this.form.is_check_one_out = this.is_check_one_out;
    },
    addMachine() {
      let url = "/erp/machine/saveMachine";
      if (this.form.machine_id) {
        url = "/erp/machine/editMachine";
      }
      this.$http.post(url, this.form).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
          this.visible = false;
          this.closeBox();
        }
      });
    },
    closeBox() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>

<style scoped>
.bottom-buttom {
  display: flex;
  flex-direction: row;
}
.el-dialog {
  width: 600px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/machine/components/edit.vue